import SvgIcon from './SvgIcon';
export * from './SvgIcon';
export default SvgIcon;
